import { cn } from "@/lib/utils";

function getScoreColor(score: number): string {
	if (score >= 85) return "text-emerald-600";
	if (score >= 70) return "text-green-600";
	if (score >= 50) return "text-amber-600";
	if (score >= 30) return "text-orange-600";
	return "text-red-600";
}

function getScoreLabel(score: number): string {
	if (score >= 85) return "Excellent";
	if (score >= 70) return "Fair";
	if (score >= 50) return "Moderate";
	if (score >= 30) return "Uneven";
	return "Unfair";
}

function getBarColor(score: number): string {
	if (score >= 85) return "bg-emerald-500";
	if (score >= 70) return "bg-green-500";
	if (score >= 50) return "bg-amber-500";
	if (score >= 30) return "bg-orange-500";
	return "bg-red-500";
}

export function FairnessGauge({ score, size = "md" }: { score: number; size?: "sm" | "md" | "lg" }) {
	const sizes = {
		sm: { text: "text-lg", label: "text-[10px]", bar: "h-1.5", gap: "gap-1" },
		md: { text: "text-3xl", label: "text-xs", bar: "h-2", gap: "gap-1.5" },
		lg: { text: "text-5xl", label: "text-sm", bar: "h-3", gap: "gap-2" },
	};
	const s = sizes[size];

	return (
		<div className={cn("flex flex-col items-center", s.gap)}>
			<div className="flex items-baseline gap-1">
				<span className={cn("font-bold tabular-nums", s.text, getScoreColor(score))}>
					{score}
				</span>
				<span className={cn("text-muted-foreground", s.label)}>/100</span>
			</div>
			<div className={cn("w-full rounded-full bg-muted overflow-hidden", s.bar)}>
				<div
					className={cn("h-full rounded-full transition-all duration-500", getBarColor(score))}
					style={{ width: `${score}%` }}
				/>
			</div>
			<span className={cn("font-medium", s.label, getScoreColor(score))}>
				{getScoreLabel(score)}
			</span>
		</div>
	);
}
